import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';
import { Goal, GoalsListResponse } from '../interfaces/models/goal.model';
import { filterActive } from '../utils/filter-active';
@Injectable({
  providedIn: 'root'
})
export class GoalService {
  constructor(private http: HttpClient) { }
  private domain = environment.domain;
  getListGoals(id: number) {
    return this.http.get(this.domain + `strategies/${id}/goals`).pipe(map((data: any) => {
      const payload = data?.data ?? {};
      return {
        goals: filterActive((payload.goals ?? []) as Goal[]),
        weight_summary: payload.weight_summary
      } as GoalsListResponse;
    }))
  }
  getGoal(strategyId: number, goalId: number) {
    return this.http.get(this.domain + `strategies/${strategyId}/goals/${goalId}`);
  }

  createGoal(model: Partial<Goal>, strategyId: number) {
    return this.http.post(this.domain + `strategies/${strategyId}/goals`, model);
  }
  updateGoals(model: Partial<Goal>, strategyId: number, goalId: number) {
    return this.http.put(this.domain + `strategies/${strategyId}/goals/${goalId}`, model);
  }
  deleteGoal(strategyId: number, PillarId: number) {
    return this.http.delete(this.domain + `strategies/${strategyId}/goals/${PillarId}`);
  }
}
